<template>
    <div>
        <CommonPopupFrame :changeBottom="0" :changeHeight="90" :isOpen="isOpen" :closeCompleteAction="() => { closeCompleteAction(PROFILE_BOX_LIST.SPECIAL_SKILL, true, false, false) }">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div @click="closeCompleteAction(PROFILE_BOX_LIST.SPECIAL_SKILL, true, false, false)" style="padding-left: 12px; margin-top: 6px; font-weight: 700; color: #808080; height: 30px; width: 50px;">닫기</div>
            <div @touchmove.stop="() => { }" style="margin-top: 31px; flex: 1; overflow-y: scroll; padding: 0 12px; padding-bottom: 20px;">
                <div style="text-align: center;">
                    <div style="font-weight: 700; font-size: 32px; line-height: 46px;">개인기</div>
                    <div style="margin-top: 15px; font-weight: 500; line-height: 24px;">회원님이 가장 자신있는 개인기를<br>한 가지를 선택할 수 있습니다.</div>
                </div>
                <div style="margin-top: 40px;">
                    <div style="font-weight: 500; font-size: 14px; margin-bottom: 24px; line-height: 24px;">능력</div>
                    <div style="display: flex; flex-wrap: wrap; gap: 12px;">
                        <div @click="setSpeciality(each)" :class="selectSpeciality === each ? 'active' : ''" v-for="each, i in specialty" :key="i" style="padding: 12px 20px; border-radius: 24px; line-height: 24px; font-weight: 500; text-align: center; border: 1px solid #d9d9d9; font-size: 14px;">
                            {{ each }}
                        </div>
                    </div>
                </div>
                <div style="margin-top: 16px;">
                    <div style="font-weight: 500; font-size: 14px; margin-bottom: 4px; line-height: 24px;">개인기</div>
                    <div style="display: flex; flex-wrap: wrap; gap: 12px;">
                        <div @click="setSkill(each)" :class="selectSkill === each ? 'active' : ''" v-for="each, i in skill" :key="i" style="padding: 12px 20px; border-radius: 24px; line-height: 24px; font-weight: 500; text-align: center; border: 1px solid #d9d9d9; font-size: 14px;">
                            {{ each }}
                        </div>
                    </div>
                </div>
            </div>
            <div style="height: 90px; padding: 0 12px;">
                <div @click="save" v-if="selectSkill !== '' && selectSpeciality !== ''" class="save_btn_active">저장하기</div>
                <div v-else class="save_btn_unactive">저장하기</div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import ResponseCode from '../../ResponseCode'
import { PROFILE_BOX_LIST } from '@/Constants'

export default {
    name: 'SettingSpecialSkill',
    components: { CommonPopupFrame },
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        closeCompleteAction: {
            type: Function,
            default: () => { },
        },
    },
    data() {
        return {
            selectSpeciality: '',
            selectSkill: '',
            specialty: ['트래핑', '킬패스', '드리블', '마무리', '크로스', '코너킥', '프리킥', '패널티킥', '경합', '몸싸움', '헤딩', '체력', '스로인', '대인 방어', '달리기', '캐칭/펀칭', '다이빙', '골킥', '빌드업'],
            skill: ['치고 달리기', '플립플랩', '스탭오버', '마르세유 턴', '아웃프런트 킥', '팬텀드리블', '태클', '라보나킥', '백숏', '시저스킥', '넛맥', '바디페인팅', '크루이프 턴'],
            PROFILE_BOX_LIST: PROFILE_BOX_LIST
        }
    },
    methods: {
        setSkill(skill) {
            this.selectSkill = skill
        },
        setSpeciality(speciality) {
            this.selectSpeciality = speciality
        },
        async save() {
            this.$GlobalStore.showProgress()

            const formData = new FormData()
            const special_skill = this.selectSpeciality + ', ' + this.selectSkill
            formData.append('special_skill', special_skill)

            const res = await this.$Axios.post('/api/profile/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

            if (res.data.code === ResponseCode.SUCCESS) {
                this.selectSpeciality = ''
                this.selectSkill = ''
                this.$GlobalStore.hideProgress()
                this.closeCompleteAction(PROFILE_BOX_LIST.SPECIAL_SKILL, true, false, true)
            }
        }
    },
    watch: {
        isOpen(newVal) {
            if (!newVal) {
                this.selectSkill = ''
                this.selectSpeciality = ''
            }
        }
    },
    created() {
        this.save = this.$Once(this.save)
    }
}
</script>

<style scoped>
.common_box {
    padding: 10px;
    border-radius: 12px;
    background-color: #f5f5f5;
    margin-top: 40px;
}

.save_btn_active {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #210f03;
    text-align: center;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}

.save_btn_unactive {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #f5f5f5;
    text-align: center;
    color: #d9d9d9;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}

.active {
    background-color: #210f03;
    color: #fff;
}
</style>